'use strict'

export let english={
  general: {
    executive: "Executive",
    projectManager: "PM",
    risks:"Risks",
    issues :"Issues"
  },
  reports: {
    heading: "Generated reports",
    highlightReport: "Latest Highlight Report",
    brief: "Program Brief",
    pid: "Program Definition Document"
  },
  identifyingProgrammeProcess: {
    title: "Recommended activities when identifying a programme:",
    activities: {
      sponsoringTheProgramme : {
        title: "Sponsoring the programme"
      },
      confirmProgramMandate: {
        title: "Confirm the programme mandate"
      },
      appointSROAndProgrammeBoard: {
        title: "Appoint the SRO and programme board"
      },
      produceProgrammeBrief: {
        title: "Produce the programme brief"
      },
      developProgrammePreparationPlan: {
        title: "Develop the programme preparation plan"
      },
      independentReview: {
        title: "Independent Review"
      },
      approvalToProceed: {
        title: "Approval to proceed"
      }
    }
  },
  definingProgrammeProcess: {
    title: "Recommended activities when defining a programme:",
    activities: {
      establishInfrastructure : {
        title: "Establish the infrastructure for 'Defining a Programme'"
      },
      establishTeam: {
        title: "Establish the team to define the programme"
      },
      identifyStakeholders: {
        title: "Identify and analyse the stakeholders"
      },
      refineVision: {
        title: "Refine the vision statement"
      },
      developBlueprint: {
        title: "Develop the blueprint"
      },
      developBenefitProfiles: {
        title: "Develop the benefit profiles"
      },
      modelBenefits: {
        title: "Model the benefits and refine the profiles"
      },
      validateBenefits: {
        title: "Validate the benefits"
      },
      designProjectsDossier: {
        title: "Design the projects dossier"
      },
      identifyTranches: {
        title: "Identify tranches"
      },
      designProgrammeOrganization: {
        title: "Design the programme organization"
      },
      developGovernanceArrangements: {
        title: "Develop the governance arrangements"
      },
      developProgrammePlan: {
        title: "Develop the programme plan"
      },
      confirmBusinessCase: {
        title: "Develop and confirm programme business case"
      },
      consolidateProgrammeDefinition: {
        title: "Consolidate the programme definition"
      },
      prepareFirstTranche: {
        title: "Prepare for first tranche"
      },
      approvalToProceed: {
        title: "Approval to proceed"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/programme/labels/english.js